import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../Component/Layout/Header';
import MemberInformationPannel from '../Component/CommonComponent/MemberInformationPannel';
import MainHeadingAddMember from '../Component/CommonComponent/MainHeadingAddMember';
import MainHeadingFilterMember from '../Component/CommonComponent/MainHeadingFilterMember';
import MainCommonDataTable from '../Component/CommonComponent/MainCommonDataTable';
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import $, { Callbacks } from 'jquery';
import { toast } from 'react-toastify';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import mixpanel from 'mixpanel-browser';
import { Link } from 'react-router-dom';
import Sidebar from '../Component/Layout/Sidebar';
import CustomHeader from '../Component/Layout/Header';
import { Layout } from 'antd';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Modal from 'react-bootstrap/Modal';
import { DownOutlined } from '@ant-design/icons';
import {
  allMember,
  exportFileFunc,
  addBulkUploadFile,
  // onCityLocation,
  memberAditionData,
  onBuildingLocation1,
  onCityLocation1,
  addBulkUploadFile2,
  ActiveListsetEdit,
} from '../Redux/action/memberAction';
import { CSVLink } from 'react-csv';

import { CheckLoader } from '../Redux/action/visitorAction';
import SwTooltip from './Common/SwTooltip/SwTooltip';
import {
  dataUser,
  logoutHandler,
  dataLocation,
  allLocationWithShortName,
} from './Helpers/util';
import { getLocationNameById } from '../utils/getLocationNameById';
import CompanyLevelSettingModal from './CommonComponent/CompanyLevelSettingModal';
import SwSelect from './Common/SwReactSelect/SwReactSelect';
import SwButton from './Common/SwButtons/SwButtons';
import SwOffCanvas from './Common/SwOffCanvas/SwOffCanvas';
import SwInput from './Common/FormComponent/SwInput';
import SwCheckbox from './Common/FormComponent/SwCheckbox';
import SwIconButton from './Common/SwIconButton/SwIconButton';
import AntDDropdown from './Common/AntDDropdown/AntDDropdown';
import AntDTable from './Common/AntDTable/AntDTable';
import EditMember from './CommonComponent/EditMember';
import axiosInstance from '../utils/axiosInstance';
import SwModal from './Common/SwModal/SwModal';

const userDataLocal = dataUser();
let UserObj = {};

try {
  UserObj = userDataLocal ? JSON.parse(userDataLocal) : {};
} catch (error) {
  console.error('Failed to parse user data:', error);
  UserObj = {}; // Fallback to empty object if parsing fails
}
const userDataLocal1 = dataLocation();
var LocationObj = JSON.parse(userDataLocal1);
const locationWithShortName = allLocationWithShortName();
var exportDataNew = [];

class ActiveMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      userid: UserObj ? UserObj.rec_id : null,
      row: 25,
      showImport: false,
      showCompanySetting: false,
      pgno: 1,
      showImportModal: false,
      city: '',
      popup: false,
      collapsed: true,
      cityError: '',
      buildingLocation: '',
      buildingLocationError: '',
      showDeleteUserList: false,
      floor: '',
      florrid: { value: '', label: 'select' },
      floorError: '',
      importExcelData: [],
      duplicateDataArray: [],
      setfilter: {},
      status: '',
      deptValue: '',
      deptValue1: '',
      deptValue2: null,
      orgDept: [],
      floorData: [],
      buildingOptions: [],
      selectedBuilding: null,
      selectedBuildingId: null,
      selectedOldBuildingId: null,
      bulkUploadErrors: [],
      showBulkUploadError: false,
      uploadSuccess: false,
      uploadedFileName: '',
      order: '',
      loaderServiceAccess: true,
      accessServiceLists: [],
      confirmcheckbox: false,
      loadingExport: (
        <div>
          <i className="bi bi-upload" /> Loading Export Members
        </div>
      ),
      users: null,
      stateValsort: {
        dropdown: false,
      },
      fileName: '',
      isSearchVisible: false,
      searchText: '',
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      locationNew: [],
      showEditMember: false, // For Edit Member OffCanvas
      footerState: null, // For Edit Member Footer
      testRec: '', // For Delete User
      setIndex: 0, // For Edit Member Navigation
      items: {}, // For Edit Member Navigation
      fnameerrorMsg: '',
      lnameerrorMsg: '',
      email_iderrorMsg: '',
      phone_noerrorMsg: '',
      nfileerrorMsg: '',
      showCompleteReviewModal: false,
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
    this.handelDropdown = this.handelDropdown.bind(this);

    this.companySettingRef = React.createRef();
    this.editMemberRef = React.createRef();
  }

  /* ==================== Methods from MainCommonDataTable ==================== */

  closeEditMember = () => {
    this.setState({ showEditMember: false });
  };

  fetchMembers = () => {
    const {
      pgno,
      row,
      company_id,
      userid,
      status,
      searchText,
      order,
      setfilter,
    } = this.state;
    // Logic copied from other methods to construct params
    let locationId = JSON.parse(localStorage.getItem('selectedLocationReview'));
    let locationParam =
      localStorage.getItem('exitReview') == 'false'
        ? locationId.map(obj => obj.value)
        : LocationObj;

    let param = {
      pgno,
      row,
      company_id,
      userid,
      location: locationParam,
      status: status,
      search: searchText,
      order: order,
      ...setfilter,
    };

    if (status === 'spoc') {
      param.spoc = 1;
      param.status = 'status'; // As per getActiveMember logic
    }

    this.props.CheckLoader();
    if (!UserObj?.company_id) {
    }
    this.props.allMember(param);
  };

  handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;

    let newOrder = this.state.order;
    if (sorter && sorter.field) {
      if (sorter.field === 'name') newOrder = 'name';
      if (sorter.field === 'email') newOrder = 'email';
      if (sorter.field === 'phone') newOrder = 'phone';
      // etc.
    }

    this.setState(
      {
        pgno: current,
        row: pageSize,
        order: newOrder,
      },
      () => {
        this.fetchMembers();
      },
    );
  };

  onFooterState = footerState => {
    this.setState({ footerState });
  };

  changeforward = () => {
    this.setState({
      setIndex: this.state.setIndex + 1,
      // loader: true, // If we want to show loader in EditMember, we might need to pass it or handle it there
    });

    var itemIndex = this.state.items[this.state.setIndex + 1];
    if (itemIndex) {
      var singleId = itemIndex.rec_id;
      let parm = {
        rec_id: singleId,
      };
      // this.props.ActiveListsetEdit(parm); // We need to add this prop
    }
  };

  changebackformward = () => {
    this.setState({
      setIndex: this.state.setIndex - 1,
      // loader: true,
    });
    var itemIndex = this.state.items[this.state.setIndex - 1];
    if (itemIndex) {
      var singleId = itemIndex.rec_id;
      let parm = {
        rec_id: singleId,
      };
      // this.props.ActiveListsetEdit(parm);
    }
  };

  sendId = (rcid, email, i, list) => {
    let parm = {
      rec_id: rcid,
      email: email,
    };

    // Fix: items should be the full list, not the single item.
    const fullList = this.props.activeUserList?.userList?.list || [];

    this.setState({
      setIndex: i,
      items: fullList,
    });

    if (this.props.ActiveListsetEdit) {
      this.props.ActiveListsetEdit(parm);
    }

    mixpanel.track('Member Management Edit', {
      PageName: 'Members',
      UserEmail: UserObj?.email,
      UserName: UserObj?.fname + ' ' + UserObj?.lname,
      UserId: UserObj?.rec_id,
      CompanyId: UserObj?.company_id,
      CompanyName: UserObj?.company_name,
      Type: 'Members',
      FirstName: list?.fname,
      LastName: list?.lname,
      EmployeeCode: list?.emp_code,
      PhoneNumber: list?.phone,
      CorporateEmail: list?.email,
      BloodGroup: list?.blood_group,
      Vaccination: list?.vaccinated,
      City: list?.city_name,
      Building: list?.business_name,
      Floor: list?.floor_name,
      EmployeeDepartment: list?.dept_name,
    });
  };

  getDelete = async userId => {
    try {
      const organizationData = JSON.parse(localStorage.getItem('headData'));
      if (!organizationData) {
        toast.error('Organization data not found in local storage.');
        return;
      }

      const res = await axiosInstance.delete(
        `${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/user/${userId}`,
        {
          headers: {
            'req-organization-id': organizationData.organizationId,
            'req-organization-type': organizationData.roomShared,
          },
        },
      );

      if (res.status === 200) {
        toast.success(res.data.message, {});
        setTimeout(() => {
          this.refreshPage1(); // Reload or refresh list
        }, 500);
      } else {
        toast.error(res.data.message, {});
      }
    } catch (error) {
      toast.error('An error occurred while deleting the user.');
      console.error('Error deleting user:', error);
      const errorMessage =
        error.response?.data?.data?.error ||
        error.response?.data?.message ||
        'An unexpected error occurred. Please try again.';
      toast.error(errorMessage);
    }
  };

  locationNameById = (locationsData, locationId) => {
    if (!Array.isArray(locationsData) || locationsData.length === 0) {
      return '-';
    }
    const locationName = locationsData.filter(
      item => locationId == item.rec_id,
    );
    if (locationName?.length > 0) {
      return locationName[0].location_short_code;
    }
    return '-';
  };

  /* ========================================================================== */

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response });
  };

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };
  toggleCollapsed = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };

  handleCloseImport = () => {
    this.setState({ showImport: false, confirmcheckbox: false });
  };

  handleOpenImport = () => {
    this.setState({ showImport: true });
  };

  showBulkUploadErrorModal = () => {
    this.setState({ showBulkUploadError: true });
  };

  handleBulkUploadError = () => {
    this.setState({ showBulkUploadError: false });
  };

  fetchBuildingData = async () => {
    const organizationData = JSON.parse(localStorage.getItem('headData'));
    if (!organizationData?.organizationId) return;

    try {
      const requestData = {
        ids: [organizationData.organizationId],
        includes: ['properties'],
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/organizations/all`,
        requestData,
      );

      const buildingOptions =
        response?.data?.data[0]?.properties?.map(property => ({
          value: property.id,
          label: property.name,
          properties: property,
        })) || [];

      this.setState({ buildingOptions });
    } catch (error) {
      console.error('Error fetching buildings:', error);
    }
  };

  handleBuildingChange = selectedBuilding => {
    if (!selectedBuilding) return;

    this.setState({
      selectedBuilding,
      selectedBuildingId: selectedBuilding.value,
      selectedOldBuildingId: selectedBuilding?.properties?.old_db_id,
      buildingLocationError: '',
      deptValue1: '',
      deptValue2: null,
    });

    if (selectedBuilding?.properties?.old_db_id) {
      this.getDepDataByLocation(selectedBuilding.properties.old_db_id);
    }
  };

  uploadImg = event => {
    const file = event.target.files[0];
    if (!file) return;

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      const repalceUrl = fileReader.result.replace('vnd.ms-excel', 'csv');
      this.setState({
        users: repalceUrl,
        fileName: file.name,
        importExcelData: file,
        fileNameError: '',
      });
    };
  };

  handleCheckBox = e => {
    if (e.target.checked === true) {
      // $('#ImportAlertModal').modal('show');
      this.setState({ confirmcheckbox: true });
      this.setState({ showImport: true });
    } else {
      this.setState({ confirmcheckbox: false });
    }
  };
  refreshPage = e => {
    let param = {
      pgno: this.state.pgno,
      status: e.target.value,
      row: 25,
      company_id: this.state.company_id,
      userid: this.state.userid,
      location: LocationObj,
    };
    this.setState({
      pgno: 1,
      row: 25,
    });
    if (!UserObj?.company_id) {
    }
    this.props.allMember(param);
  };
  refreshPage1 = () => {
    window.location.reload();
  };
  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  handleDuplicate = (e, data) => {
    this.setState({ [e.target.name]: e.target.value });

    const newDuplicateArray = [...this.state.duplicateDataArray];

    const a = newDuplicateArray.findIndex(
      element => element.phone === data.phone,
    );

    newDuplicateArray.splice(a, 1);

    newDuplicateArray.push(data);

    this.setState({ duplicateDataArray: newDuplicateArray });
  };

  addimportfile = async e => {
    e.preventDefault();

    const {
      deptValue1,
      confirmcheckbox,
      importExcelData,
      selectedBuilding,
      selectedBuildingId,
      fileName,
    } = this.state;

    if (!selectedBuilding) {
      this.setState({ buildingLocationError: 'Building is Required' });
      return;
    }

    if (!fileName) {
      this.setState({ fileNameError: 'File is Required' });
      return;
    }

    if (!fileName.includes('.xlsx')) {
      this.setState({ fileNameError: 'Please select the correct file' });
      return;
    }

    const orgData = JSON.parse(localStorage.getItem('headData'));
    if (!orgData?.organizationId) {
      console.error('Missing organization ID');
      return;
    }

    const formData = new FormData();
    formData.append('file', importExcelData);
    formData.append('property_id', selectedBuildingId);
    formData.append('user_dept_id', deptValue1 || '');
    formData.append('overwrite', confirmcheckbox ? 'true' : 'false');
    formData.append('organization_id', orgData.organizationId);

    try {
      const { success, validationErrors } = await this.props.addBulkUploadFile(
        formData,
      );

      if (success) {
        this.setState({
          uploadSuccess: true,
          uploadedFileName: fileName,
          buildingLocationError: '',
          fileNameError: '',
          showImport: false,
        });

        setTimeout(() => {
          this.setState(
            {
              fileName: '',
              selectedBuilding: null,
              selectedBuildingId: null,
              selectedOldBuildingId: null,
              importExcelData: null,
              deptValue2: null,
              deptValue1: '',
              confirmcheckbox: false,
              showImportModal: false,
              uploadSuccess: false,
              uploadedFileName: '',
            },
            () => {
              $('.close').click();
              window.location.reload();
            },
          );
        }, 3500);
      } else if (validationErrors) {
        const parsedErrors = [];

        const fieldPatterns = [
          { keys: ['first name', 'firstname', 'first_name'], label: 'First Name', dataKeys: ['First Name', 'FirstName', 'first_name'] },
          { keys: ['last name', 'lastname', 'last_name'], label: 'Last Name', dataKeys: ['Last Name', 'LastName', 'last_name'] },
          { keys: ['full name'], label: 'Full Name', dataKeys: ['Full Name', 'Name'] },
          { keys: ['employee id', 'emp id', 'employee_id', 'emp_id', 'employee code', 'emp code', 'emp_code'], label: 'Emp Code', dataKeys: ['Emp Code', 'Employee ID', 'Emp ID', 'employee_id'] },
          { keys: ['date of birth', 'dob', 'birth'], label: 'Date of Birth', dataKeys: ['Date of Birth', 'DOB'] },
          { keys: ['date of joining', 'doj', 'joining'], label: 'Date of Joining', dataKeys: ['Date of Joining', 'DOJ'] },
          { keys: ['designation'], label: 'Designation', dataKeys: ['Designation'] },
          { keys: ['department', 'dept'], label: 'Department', dataKeys: ['Department', 'Dept'] },
          { keys: ['building', 'location', 'property'], label: 'Building', dataKeys: ['Building', 'Location', 'Property'] },
          { keys: ['floor'], label: 'Floor', dataKeys: ['Floor'] },
          { keys: ['specially abled'], label: 'Specially Abled', dataKeys: ['Specially Abled'] },
          { keys: ['gender'], label: 'Gender', dataKeys: ['Gender - (Male - 1, Female - 2, Others - 3)', 'Gender'] },
          { keys: ['status'], label: 'Status', dataKeys: ['Status'] },
          { keys: ['phone', 'mobile', 'contact'], label: 'Phone No', dataKeys: ['Phone No', 'Phone', 'Mobile', 'Contact'] },
          { keys: ['email'], label: 'Email', dataKeys: ['Email', 'Email Id', 'EmailId'] },
          { keys: ['role'], label: 'Role', dataKeys: ['Role'] },
          { keys: ['blood'], label: 'Blood Group', dataKeys: ['Blood Group'] },
          { keys: ['address'], label: 'Address', dataKeys: ['Address'] },
          { keys: ['payroll'], label: 'Payroll', dataKeys: ['Payroll'] },
          { keys: ['project'], label: 'Project', dataKeys: ['Project'] },
        ];

        const getInputForField = (rowData, dataKeys) => {
          for (const key of dataKeys) {
            if (rowData[key] !== undefined && rowData[key] !== null && rowData[key] !== '') {
              return String(rowData[key]);
            }
          }
          return '';
        };

        const detectField = issue => {
          const lower = issue.toLowerCase();
          const quotedMatch = issue.match(/['"`]([^'"`]+)['"`]/);
          for (const pattern of fieldPatterns) {
            if (pattern.keys.some(k => lower.includes(k))) {
              return pattern;
            }
          }
          if (quotedMatch) {
            const guessed = quotedMatch[1];
            return {
              label: guessed.charAt(0).toUpperCase() + guessed.slice(1),
              dataKeys: [guessed],
            };
          }
          return null;
        };

        validationErrors.forEach(err => {
          const errStr = typeof err === 'string' ? err : JSON.stringify(err);
          const rowMatch = errStr.match(/Row\s+(\d+)/i);
          const row = rowMatch ? rowMatch[1] : '';

          let rowData = {};
          const rowDataMatch = errStr.match(/row data:\s*(\{.*\})/i);
          if (rowDataMatch) {
            try {
              rowData = JSON.parse(rowDataMatch[1]);
            } catch (parseErr) {
              console.error('Failed to parse row data', parseErr);
            }
          }

          const cleanMessage = errStr
            .replace(/Row\s+\d+:/i, '')
            .replace(/row data:\s*\{.*\}/i, '')
            .trim();

          const issues = cleanMessage
            .split(/;|\n/)
            .map(s => s.trim())
            .filter(Boolean);

          if (issues.length === 0 && cleanMessage) {
            issues.push(cleanMessage);
          }

          issues.forEach(issue => {
            const detected = detectField(issue);
            const field = detected ? detected.label : 'General';
            const input = detected ? getInputForField(rowData, detected.dataKeys) : '';
            const requiredFormat = issue || 'Invalid value';

            parsedErrors.push({ row, field, input, requiredFormat });
          });
        });

        if (document.getElementById('fileupload')) {
          document.getElementById('fileupload').value = null;
        }
        this.setState({
          bulkUploadErrors: parsedErrors,
          showBulkUploadError: true,
          showImportModal: false,
          fileName: '',
          importExcelData: null,
          selectedBuilding: null,
          selectedBuildingId: null,
          selectedOldBuildingId: null,
          deptValue1: '',
          deptValue2: null,
          confirmcheckbox: false,
          buildingLocationError: '',
          fileNameError: '',
        });
      }
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  addimportfile1 = async () => {
    let param = {
      company_id: this.state.company_id,
      floor_id: this.state.florrid?.value,
      users: UserObj ? UserObj.rec_id : null,
      overwrite_opt: this.state.confirmcheckbox === true ? '1' : '2',
    };
    if (
      this.state.duplicateDataArray?.length == 0 &&
      this.props.importData.data?.finalDuplicate.length > 0
    ) {
      toast.error(`please select at least one duplicate record`, {});
    } else {
      if (!UserObj?.company_id) {
      }

      this.props.addBulkUploadFile2(
        param,
        this.state.duplicateDataArray,
        cb => {
          this.setuserlist();
          $('.close').click();
        },
      );
    }
  };

  setSelectsort = value => {
    this.setState(
      {
        order: value,
      },
      () => {
        const param = {
          row: this.state.row,
          pgno: this.state.pgno,
          order: value,
          company_id: this.state.company_id,
          userid: this.state.userid,
          location: LocationObj,
        };

        this.props.allMember(param);
      },
    );
  };

  getDepDataByLocation = loc_id => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    if (!UserObj?.company_id) {
    }
    axios
      .get(
        `${process.env.REACT_APP_API_URL}department/getActiveDepartment/${this.state.company_id
        }/${loc_id}`,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )

      .then(response => {
        if (response.data && response.data.status == 'success') {
          this.setState({
            orgDept: response.data.data.activeDepartment,
          });
        }
      })

      .catch(err => {
        console.log('Error: ' + err);
      });
  };

  selectRows = e => {
    let locationId = JSON.parse(localStorage.getItem('selectedLocationReview'));
    this.setState({
      [e.target.name]: e.target.value,
    });
    let parms1 = {
      order: this.state.order,
      row: e.target.value,
      status: this.state.status,
      pgno: this.state.pgno,
      company_id: this.state.company_id,
      userid: this.state.userid,
      location:
        localStorage.getItem('exitReview') == 'false'
          ? locationId.map(obj => obj.value)
          : LocationObj,
    };
    let parms2 = {
      ...this.state.setfilter,
      order: this.state.order,
      row: e.target.value,
      pgno: this.state.pgno,
      company_id: this.state.company_id,
      userid: this.state.userid,
      location:
        localStorage.getItem('exitReview') == 'false'
          ? locationId.map(obj => obj.value)
          : LocationObj,
    };
    let vparam = this.state.status != '' ? parms1 : parms2;
    if (!UserObj?.company_id) {
    }
    this.props.allMember(vparam, 'default');
  };

  chnageSelectMembers = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    let param = {
      pgno: this.state.pgno,
      row: 25,
      status: e.target.value,
      company_id: this.state.company_id,
      userid: this.state.userid,
      location: LocationObj,
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
    }
    this.props.allMember(param);
  };

  getActiveMember = status => {
    var param2 = {};
    this.setState({ status: status }, () => {
      if (status === 'spoc') {
        param2 = {
          pgno: this.state.pgno,
          company_id: this.state.company_id,
          row: this.state.row,
          spoc: 1,
          status: 'status',
          userid: this.state.userid,
          location: LocationObj,
        };
      } else {
        param2 = {
          pgno: this.state.pgno,
          company_id: this.state.company_id,
          row: this.state.row,
          status: this.state.status,
          userid: this.state.userid,
          location: LocationObj,
        };
      }
      this.props.CheckLoader();
      if (!UserObj?.company_id) {
      }
      this.props.allMember(param2);
    });
  };

  handleDuplicateMail = (e, data) => {
    const newDuplicateEmailArray = [...this.state.duplicateDataArray];
    const index = newDuplicateEmailArray.findIndex(
      element => element.email === data.email,
    );
    if (index > -1) {
      newDuplicateEmailArray.splice(index, 1);
      newDuplicateEmailArray.push(data);
    } else {
      newDuplicateEmailArray.push(data);
    }
    this.setState({ duplicateDataArray: newDuplicateEmailArray });
  };

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
    });
    let parms1 = {};
    let locationId = JSON.parse(localStorage.getItem('selectedLocationReview'));
    if (this.state.status == 'spoc') {
      parms1 = {
        order: this.state.order,
        row: this.state.row,
        status: this.state.status,
        pgno: this.state.pgno + 1,
        company_id: this.state.company_id,
        search: this.state.searchText,
        userid: this.state.userid,
        location:
          localStorage.getItem('exitReview') == 'false'
            ? locationId.map(obj => obj.value)
            : LocationObj,
        spoc: 1,
      };
    } else {
      parms1 = {
        order: this.state.order,
        row: this.state.row,
        status: this.state.status,
        pgno: this.state.pgno + 1,
        company_id: this.state.company_id,
        search: this.state.searchText,
        userid: this.state.userid,
        location:
          localStorage.getItem('exitReview') == 'false'
            ? locationId.map(obj => obj.value)
            : LocationObj,
      };
    }
    let parms2 = {
      ...this.state.setfilter,
      order: this.state.order,
      row: this.state.row,
      pgno: this.state.pgno + 1,
      company_id: this.state.company_id,
      search: this.state.searchText,
      userid: this.state.userid,
      location:
        localStorage.getItem('exitReview') == 'false'
          ? locationId.map(obj => obj.value)
          : LocationObj,
    };
    let vparam = this.state.status != '' ? parms1 : parms2;
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
    }
    this.props.allMember(vparam);

    let newParam = {
      pgno: this.state.pgno + 1,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
    }
    this.props.exportFileFunc(newParam);
  }

  pageBackword() {
    this.setState({
      pgno: this.state.pgno - 1,
    });
    let parms1 = {};
    let locationId = JSON.parse(localStorage.getItem('selectedLocationReview'));
    if (this.state.status == 'spoc') {
      parms1 = {
        order: this.state.order,
        row: this.state.row,
        status: this.state.status,
        pgno: this.state.pgno - 1,
        company_id: this.state.company_id,
        search: this.state.searchText,
        userid: this.state.userid,
        location:
          localStorage.getItem('exitReview') == 'false'
            ? locationId.map(obj => obj.value)
            : LocationObj,
        spoc: 1,
      };
    } else {
      parms1 = {
        order: this.state.order,
        row: this.state.row,
        status: this.state.status,
        pgno: this.state.pgno - 1,
        company_id: this.state.company_id,
        search: this.state.searchText,
        userid: this.state.userid,
        location:
          localStorage.getItem('exitReview') == 'false'
            ? locationId.map(obj => obj.value)
            : LocationObj,
      };
    }
    let parms2 = {
      ...this.state.setfilter,
      order: this.state.order,
      row: this.state.row,
      pgno: this.state.pgno - 1,
      company_id: this.state.company_id,
      search: this.state.searchText,
      userid: this.state.userid,
      location:
        localStorage.getItem('exitReview') == 'false'
          ? locationId.map(obj => obj.value)
          : LocationObj,
    };
    let vparam = this.state.status != '' ? parms1 : parms2;

    let newData = {
      pgno: this.state.pgno - 1,
      row: this.state.row,
      company_id: this.state.company_id,
      location:
        localStorage.getItem('exitReview') == 'false'
          ? locationId.map(obj => obj.value)
          : LocationObj,
    };

    this.props.CheckLoader();
    if (!UserObj?.company_id) {
    }
    this.props.allMember(vparam);
    this.props.exportFileFunc(newData);
  }

  setuserlist = () => {
    let locationId = JSON.parse(localStorage.getItem('selectedLocationReview'));
    let param = {
      pgno: this.state.pgno,
      company_id: this.state.company_id,
      row: this.state.row,
      userid: this.state.userid,
      status: 'notInactive',
      location:
        localStorage.getItem('exitReview') == 'false'
          ? locationId.map(obj => obj.value)
          : LocationObj,
    };
    if (!UserObj?.company_id) {
    }
    this.props.allMember(param);
  };

  // Holds the pending debounce timer so each keystroke can cancel the previous one.
  searchDebounceTimer = null;

  // Fires the actual API call with the latest search text.
  fetchMembersBySearch = () => {
    let param = {
      // Always start a new search from the first page, otherwise a narrowed
      // result set has no current page and the list shows up empty.
      pgno: 1,
      company_id: this.state.company_id,
      row: this.state.row,
      // Trim so pasted values (which often carry leading/trailing spaces or a
      // newline) match the backend the same way typed text does.
      search: this.state.searchText.trim(),
      status: this.state.status,
      userid: this.state.userid,
      location: LocationObj,
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
    }
    this.props.allMember(param);
    this.getAllExportData(param);
  };

  changeFilterData = event => {
    const value = event.target.value;
    // Update the input value immediately so typing stays responsive, and reset
    // to page 1 so the search runs against the first page of results.
    this.setState({ searchText: value, pgno: 1 });
    // ...but debounce the API call so we only fetch once the user pauses typing.
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.fetchMembersBySearch();
    }, 500);
  };

  clearSearchBox = () => {
    this.setState({ searchText: '' });
  };

  setExport = () => {
    var paramData = {
      pgno: 1,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
    }
    this.props.exportFileFunc(paramData);
  };

  componentWillUnmount() {
    // Cancel any pending debounced search so we don't fetch after unmount.
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  }

  componentDidMount() {
    if (this.props.UserObj) {
      this.setState({
        userRole: this.props.UserObj.role_data || [],
      });
    }
    let locationShort = JSON.parse(locationWithShortName);
    this.setuserlist();
    this.setExport();
    this.getAllExportData();
    this.props.memberAditionData(this.state.company_id);
    this.props.onCityLocation1({
      location: LocationObj,
    });
    this.fetchBuildingData();
    this.setState({ locationNew: locationShort });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.UserObj !== this.props.UserObj) {
      this.setState({
        userRole: this.props.UserObj.role_data || [],
      });
    }
  }

  componentWillMount() {
    this.fetchServiceAccess();
  }

  handleLanguage = langValue => {
    this.setState({
      setfilter: langValue,
    });
  };

  exportClick() {
    mixpanel.track('Member Management Export', {
      PageName: 'Members',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Members',
    });
  }

  importClick() {
    mixpanel.track('Member Management Import', {
      PageName: 'Members',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Members',
    });
  }

  closeCompanySetting = () => {
    this.setState({ showCompanySetting: false });
  };

  async getTotalCount() {
    let params = {
      pgno: 1,
      row: this.state.row,
      company_id: this.state.company_id,
      userid: this.state.userid,
      location: LocationObj,
    };
    if (!UserObj?.company_id) {
    }
    let authToken = JSON.parse(localStorage.getItem('headData'));

    const total = await axios
      .post(
        `${process.env.REACT_APP_API_URL}user/member_list_by_locationv2`,
        params,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        return response?.data?.data?.data?.total;
      });
    // this.getAllExportData(total);
  }

  // componentWillReceiveProps(nextProps) {
  //     this.getAllExportData();
  // }

  getAllExportData = exportData => {
    if (!UserObj?.company_id) {
    }

    const genderData = data => {
      if (data == 1) {
        return 'Male';
      } else if (data == 2) {
        return 'Female';
      } else if (data == 3) {
        return 'Transgender';
      } else {
        return '-';
      }
    };

    const dateOfJoining = date => {
      if (!date || date == '') return '-';

      const now = new Date(date);

      const day = ('0' + now.getDate()).slice(-2);

      const month = ('0' + (now.getMonth() + 1)).slice(-2);

      const today =
        month == 'aN' || day == 'aN'
          ? ''
          : now.getFullYear() + '-' + month + '-' + day;

      return today;
    };
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .post(
        `${process.env.REACT_APP_API_URL}manageMembers/export-member`,
        exportData
          ? exportData
          : {
            // pgno: 1,
            // row: totalCount,
            company_id: this.state.company_id,
            email: this.state.filetEmail,
            empname: this.state.filtername,
            phone: this.state.filterPhone,
            status: this.state.filterStatus,
            user_role_id: this.state.filterrole,
            city: this.state.filtercity,
            building: this.state.filterbuilding,
            vaccinated: this.state.filtervacinated,
            userid: this.state.userid,
            location: LocationObj,
          },
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        exportDataNew = response.data.memberData;
        const headers = [
          { label: 'Employee Code', key: 'emp_code' },
          { label: 'First Name', key: 'fname' },
          { label: 'Last Name', key: 'lname' },
          { label: 'Email', key: 'email' },
          { label: 'Phone No', key: 'phone' },
          { label: 'Company name', key: 'company_name' },
          { label: 'Floor', key: 'floor_name' },
          { label: 'Location    ', key: 'location_name' },
          { label: 'Department', key: 'dept_name' },
          { label: 'Status  ', key: 'Status' },
          { label: 'DOB', key: 'dob' },
          { label: 'Address', key: 'address' },
          { label: 'Blood Group', key: 'blood_group' },
          { label: 'KYC Proof', key: 'kyc_file' },
          { label: 'Emergency Contact No', key: 'emergency_contact' },
          { label: 'Total No of vehicle', key: 'setLength' },
          { label: 'RF ID No 1', key: 'tag_id' },
          { label: 'Vehicle Type', key: 'typeWheler' },
          { label: 'Vehicle No', key: 'vehicle_number' },
          { label: 'RF ID assigned Date', key: 'modified_at' },
          { label: 'Is Spoc', key: 'is_spoc' },
          { label: 'Spoc Department', key: 'deptData' },
          { label: 'Role Name', key: 'role_name' },
          { label: 'Designation', key: 'designation' },
          { label: 'Gender', key: 'gender' },
          { label: 'Date Of Joining', key: 'date_of_joining' },
          { label: 'Payroll', key: 'payroll' },
          { label: 'Project', key: 'project' },
          { label: 'Specially Abled', key: 'specially_abled' },
        ];
        var arr2 = exportDataNew.map(v => ({
          emp_code: v.emp_code,
          fname: v.fname,
          lname: v.lname,
          email: v.email,
          phone: v.phone,
          company_name: v.company_name,
          floor_name: v.floor_name,
          location_name: getLocationNameById(
            this.state.locationNew,
            v.location_id,
          )
            ? getLocationNameById(this.state.locationNew, v.location_id)
            : v.location_name,
          dept_name: v.dept_name,
          Status: v.is_active,
          dob: v.dob,
          address: v.address,
          blood_group: v.blood_group,
          kyc_file: v.kyc_file,
          emergency_contact: v.emergency_contact,
          setLength: v.setLength,
          tag_id: v.tag_id,
          typeWheler: v.typeWheler,
          vehicle_number: v.vehicle_number,
          modified_at: v.modified_at,
          is_spoc: v.is_spoc,
          deptData: v.deptData,
          role_name: v.role_name,
          designation: v.designation,
          gender: genderData(v.gender),
          date_of_joining: dateOfJoining(v.date_of_joining),
          payroll: v.payroll,
          project: v.project,
          specially_abled: v.specially_abled,
        }));
        this.setState({
          loadingExport: (
            <div
              onClick={() => {
                this.exportClick();

                const worksheet = XLSX.utils.json_to_sheet(arr2);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Members');
                XLSX.utils.sheet_add_aoa(
                  worksheet,
                  [headers.map(header => header.label)],
                  { origin: 'A1' },
                );

                const excelBuffer = XLSX.write(workbook, {
                  bookType: 'xlsx',
                  type: 'array',
                });

                const data = new Blob([excelBuffer], {
                  type:
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                saveAs(data, 'Memberlist.xlsx');
              }}
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <i className="bi bi-upload" />
              <span>Export Members</span>
            </div>
          ),
        });

        if (response.status === 200) {
          // $('.close').click();
        }
      });
  };

  closeAddMember = () => {
    this.setState({ showCompanySetting: false });
  };

  getAllFloorData(building) {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    axios

      .post(
        `${process.env.REACT_APP_API_URL}user/floor`,

        {
          buildingid: building?.value,
        },
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )

      .then(response => {
        this.setState({
          floorData: response.data.data,
        });
      });
  }

  handleChange4 = city => {
    this.setState({
      city: city,
      cityError: '',
      buildingLocation: '',
      floor: '',
      deptValue: '',
      floorData: [],
    });
    let parm = {
      spoc: this.state.userid,
      client: this.state.company_id,
      city: city?.value,
    };
    // this.props.onCityLocation(parm);
    this.props.onBuildingLocation1(parm);
  };

  handleFloor = floor => {
    this.setState({
      floor: floor,
      florrid: floor,
      floorError: '',
      deptValue: '',
    });
  };

  handleReset = () => {
    if (document.getElementById('fileupload'))
      document.getElementById('fileupload').value = null;
    this.setState({
      floor: '',
      buildingLocation: '',
      city: '',
      fileName: '',
      deptValue: '',
      deptValue1: '',
      deptValue2: null,
      selectedBuilding: null,
      selectedBuildingId: null,
      selectedOldBuildingId: null,
      importExcelData: null,
      confirmcheckbox: false,
      buildingLocationError: '',
      fileNameError: '',
    });
  };

  handleBuilding = building => {
    this.setState({
      ...this.state,
      buildingLocation: building,
      buildingLocationError: '',
      floor: '',
      deptValue: '',
    });
    this.getAllFloorData(building);
    this.getDepDataByLocation(building?.value);
  };

  changeDept = department => {
    this.setState({
      deptValue: department?.value || '',
      deptValue1: department?.value || '',
      deptValue2: department,
      departError: '',
    });
  };

  completeReview = () => {
    let lastMonth = moment()
      .subtract(1, 'month')
      .format('MMM YYYY');
    let locationId = JSON.parse(localStorage.getItem('selectedLocationReview'));
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const params = {
      company_id: UserObj.company_id,
      userid: UserObj.rec_id,
      location: locationId.map(obj => obj.value),
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}userReview/insert-review`,
        params,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(res => {
        if (res.data.status == 'success') {
          toast.configure();
          toast.success(
            `Monthly data review is completed successfully for ${locationId.map(
              obj => obj.label,
            )} of ${lastMonth}`,
            {},
          );
          setTimeout(() => {
            window.location.reload();
          }, 5000);
        } else {
          toast.configure();
          toast.error(res.data.message, {});
        }
      });
    localStorage.setItem('exitReview', true);
    localStorage.removeItem('selectedLocationReview');
  };

  exitReview = () => {
    localStorage.setItem('exitReview', true);
    localStorage.removeItem('selectedLocationReview');
  };

  render() {
    const uniqueRowCount = new Set(
      this.state.bulkUploadErrors?.map(err => err.row),
    ).size;
    let selectedLocationReview = JSON.parse(
      localStorage.getItem('selectedLocationReview'),
    );
    let labelName =
      selectedLocationReview && selectedLocationReview.map(obj => obj.label);

    const finalDuplicate = this.props.importData?.data?.finalDuplicate;
    const invalidDataStatus = this.props.importData?.data?.invalidDataStatus;
    const NewCity1 = this.props.CityData1.CityData1;

    const BuildingData = this.props.CityData1.BuildingData1;

    const options5 = [];
    if (BuildingData !== 0) {
      BuildingData &&
        BuildingData.map((items, i) => {
          options5.push({
            value: items.rec_id,
            label: items.location_name,
          });
        });
    }

    const options8 = [];
    this.state.orgDept.map(dept =>
      options8.push({ value: dept.id, label: dept.dept_name }),
    );

    const options6 = [];
    if (this.state.floorData) {
      this.state.floorData.map(items => {
        return options6.push({
          value: items.rec_id,
          label: items.business_name,
        });
      });
    }

    const options4 = [];

    if (NewCity1 !== 0) {
      NewCity1 &&
        NewCity1.map((items, i) => {
          options4.push({ value: items.city_id, label: items.city_name });
        });
    }
    const { userRole } = this.state;

    const ManageMembers = userRole.find(
      element =>
        Number(element.service_id) === 1 &&
        (element.role_for_read == '1' || element.role_for_write == '1'),
    );

    const ManageApproval1 = userRole.find(
      element => element.service_id == '23',
    );

    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        render: (_, record) => (
          <div className="d-flex">
            {record.utype == 1 ? (
              <SwTooltip content={record.role_name} placement="right">
                <span className="cursor-pointer">
                  <i class="bi bi-person-fill-gear me-1" />
                </span>
              </SwTooltip>
            ) : (
              <span
                style={{ width: '12px', display: 'inline-block' }}
                className="pr-1"
              >
                &nbsp;
              </span>
            )}
            <span>
              {record.fname} {record.lname}
            </span>
          </div>
        ),
      },
      { title: 'Corporate Email', dataIndex: 'email' },
      { title: 'Phone', dataIndex: 'phone' },
      {
        title: 'Building Location',
        render: (_, record) => (
          <span className="capitalCase">
            {record.floor_name},{' '}
            {this.locationNameById(this.state.locationNew, record.location_id)}
          </span>
        ),
      },
      ...(UserObj?.company_id != Number(process.env.REACT_APP_TALBOT_COM_ID) &&
        UserObj?.company_id != Number(process.env.REACT_APP_PROZO_COM_ID)
        ? [
          {
            title: 'Last Active On App',
            minWidth:150,
            dataIndex: 'lastActivity',
            render: val =>
              val == null
                ? '-'
                : moment.unix(val).format('YYYY-MM-DD HH:mm:ss'),
          },
        ]
        : []),
      {
        title: 'Department',
        minWidth:150,
        dataIndex: 'dept_name',
        render: val => (val != null && val != '' ? val : 'N/A'),
      },
      {
        title: 'Status',
        minWidth:150,
        render: (_, record, index) => (
          <div className="statusRelate">
            {record.is_active == 1 &&
              record.isSpocApproved == 0 &&
              ((ManageMembers && ManageMembers.role_for_write == '1') ||
                ManageMembers?.role_for_read == '1') ? (
              <SwTooltip
                content={'Forbidden Access'}
                placement="top"
              >
                <SwButton
                  variant="dark-outline"
                  size="sm"
                  disabled={
                    !(ManageApproval1 && ManageApproval1?.role_for_write == '1')
                  }
                  onClick={() => {
                    this.sendId(record.rec_id, record.email, index, record);
                    this.setState({ showEditMember: true }); // 👈 ADD THIS
                  }}
                >
                Decide
                </SwButton>
              </SwTooltip>
            ) : (
              <div
                className={
                  record.is_active == 1 && record.isSpocApproved == 1
                    ? 'SwTextSuccess'
                    : 'SwTextDanger'
                }
              >
                {record.is_active == 1 && record.isSpocApproved == 1
                  ? 'Has access'
                  : 'No access'}
              </div>
            )}
          </div>
        ),
      },
      {
        title: 'Edit',
        align: 'center',
        render: (_, record, index) =>
          !(record.is_active === 1 && record.isSpocApproved === 0) && (
            <div
              className="pointerCursor pulse"
              onClick={() => {
                this.sendId(record.rec_id, record.email, index, record);
                this.setState({ showEditMember: true });
              }}
            >
              <i class="bi bi-pencil-fill" />
            </div>
          ),
      },
      {
        title: 'Delete',
        align: 'center',
        render: (_, record) =>
          (record.is_active == 1 && record.isSpocApproved == 2) ||
            (record.is_active == 0 && record.isSpocApproved == 1) ? (
            <i
              className="fa fa-trash"
              style={{ color: 'red', cursor: 'pointer' }}
              aria-hidden="true"
              onClick={() =>
                this.setState({
                  showDeleteUserList: true,
                  testRec: record.rec_id,
                })
              }
            />
          ) : (
            ''
          ),
      },
    ];

    if (!ManageMembers) {
      return <Navigate to="/Dashboard" />;
    }

    const activeUserList = this.props.activeUserList.userList;
    const exportlistData = this.props.exportList.exportData;

    const listLength =
      this.props.activeUserList.userList?.list !== undefined
        ? this.props.activeUserList.userList?.list.length
        : 0;

    const loader = this.props.activeUserList.loader;
    const loader1 = this.props.importData;

    const Loader = this.props.visitorReducer.loader;
    let serviceAccess = true;
    const serviceAccessId = 1;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }

    return (
      <>
        <Layout>
          <Sidebar collapsed={this.state.collapsed} />

          <CustomHeader
            collapsed={this.state.collapsed}
            toggleCollapsed={this.toggleCollapsed}
            activePg={this.state.pgno}
            activeRow={this.state.row}
          />

          <Layout
            className={
              this.state.collapsed
                ? 'PageLayout CollapsedPageLayout'
                : 'PageLayout'
            }
          >
            {serviceAccess === true ? (
              <>
                <div
                  className="custome modal right fade "
                  id="myModal_sort2"
                  data-backdrop="static"
                >
                  <div className="modal-dialog customfullwidthmodal modal-dialog-scrollable">
                    <div className="modal-content ">
                      <div
                        className="modal-header formTitle"
                        style={{
                          color: 'black',
                        }}
                      >
                        Review Imported Data
                        <button
                          type="button"
                          className="relateDox close p-0 m-0"
                          data-dismiss="modal"
                          onClick={this.handleReset}
                        >
                          x
                        </button>
                      </div>

                      <div
                        className="modal-body"
                        style={{ minHeight: '200px' }}
                      >
                        {loader === true ? (
                          <div className="p-4">
                            {this.props.importData.data?.validUpdateCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'green',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.validUpdateCount}{' '}
                                {this.props.importData.data
                                  ?.validUpdateCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                updated in the system
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.deactivatedAccCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {
                                  this.props.importData.data
                                    ?.deactivatedAccCount
                                }{' '}
                                {this.props.importData.data
                                  ?.deactivatedAccCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}
                                deactivated in the system
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidEmailCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.invalidEmailCount}{' '}
                                {this.props.importData.data
                                  ?.invalidEmailCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid email
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data
                              ?.invalidDateOfJoiningCount > 0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {
                                  this.props.importData.data
                                    ?.invalidDateOfJoiningCount
                                }{' '}
                                {this.props.importData.data
                                  ?.invalidDateOfJoiningCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid Date Of Joining
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data
                              ?.invalidDesignationCount > 0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {
                                  this.props.importData.data
                                    ?.invalidDesignationCount
                                }{' '}
                                {this.props.importData.data
                                  ?.invalidDesignationCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid Designation
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidGenderCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.invalidGenderCount}{' '}
                                {this.props.importData.data
                                  ?.invalidGenderCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid Gender
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidPayrollCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {
                                  this.props.importData.data
                                    ?.invalidPayrollCount
                                }{' '}
                                {this.props.importData.data
                                  ?.invalidPayrollCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid Payroll
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidProjectCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {
                                  this.props.importData.data
                                    ?.invalidProjectCount
                                }{' '}
                                {this.props.importData.data
                                  ?.invalidProjectCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid Project
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data
                              ?.invalidSpeciallyAbledCount > 0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {
                                  this.props.importData.data
                                    ?.invalidSpeciallyAbledCount
                                }{' '}
                                {this.props.importData.data
                                  ?.invalidSpeciallyAbledCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid specially Abled
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidStatusCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.invalidStatusCount}{' '}
                                {this.props.importData.data
                                  ?.invalidStatusCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid status
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidNameCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.invalidNameCount}{' '}
                                {this.props.importData.data
                                  ?.invalidNameCount === 1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid name
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.invalidPhoneCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'red',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.invalidPhoneCount}{' '}
                                {this.props.importData.data
                                  ?.invalidPhoneCount === 1 ? (
                                  <span>Record </span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                found for invalid phone
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.nothingToUpdate > 0 ? (
                              <p
                                style={{
                                  background: 'green',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.nothingToUpdate}{' '}
                                {this.props.importData.data?.nothingToUpdate ===
                                  1 ? (
                                  <span>Record</span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                unchanged in the system
                              </p>
                            ) : (
                              ''
                            )}

                            {this.props.importData.data?.validInsertCount >
                              0 ? (
                              <p
                                style={{
                                  background: 'green',
                                  color: 'white',
                                  fontWeight: '600',
                                  padding: '5px 15px',
                                }}
                              >
                                {this.props.importData.data?.validInsertCount}{' '}
                                {this.props.importData.data
                                  ?.validInsertCount === 1 ? (
                                  <span>Record </span>
                                ) : (
                                  <span>Records</span>
                                )}{' '}
                                added in the system
                              </p>
                            ) : (
                              ''
                            )}

                            <div className="row">
                              <div className="col-md-4 col-xl-4 col-lg-12">
                                <div className="formAddmemGrid">
                                  <label htmlFor="city">
                                    City <span className="Required">*</span>
                                  </label>
                                  <p>{this.props.importData.data?.cityName}</p>
                                </div>
                              </div>

                              <div className="col-md-4 col-xl-4 col-lg-12">
                                <div className="formAddmemGrid">
                                  <label htmlFor="building">
                                    Building
                                    <span className="Required">*</span>
                                  </label>
                                  <p>
                                    {this.props.importData.data?.buildingName}
                                  </p>
                                </div>
                              </div>

                              <div className="col-md-4 col-xl-4 col-lg-12">
                                <div className="formAddmemGrid">
                                  <label htmlFor="floor">
                                    Floor <span className="Required">*</span>
                                  </label>
                                  <p>{this.props.importData.data?.floorName}</p>
                                </div>
                              </div>
                            </div>

                            {finalDuplicate?.length > 0 ? (
                              <>
                                <p
                                  style={{
                                    color: 'black',
                                    fontWeight: 'bold',
                                    marginTop: '15px',
                                  }}
                                >
                                  Duplicate Records
                                </p>
                              </>
                            ) : (
                              <p
                                style={{
                                  color: 'black',
                                  fontWeight: 'bold',
                                  marginTop: '10px',
                                }}
                              >
                                No Duplicate Records Found
                              </p>
                            )}

                            {finalDuplicate?.length > 0 ? (
                              <>
                                <p
                                  style={{
                                    color: 'grey',
                                    // fontWeight: '800',
                                    marginTop: '20px',
                                  }}
                                >
                                  Please choose one record out of the duplicates
                                </p>
                              </>
                            ) : (
                              ''
                            )}

                            <>
                              {finalDuplicate?.map(ele => {
                                return (
                                  <div className="commonTable customfullwidthmodal2">
                                    <table className="table customeTable customeTable1">
                                      <thead>
                                        <tr className="noborderHeader">
                                          <th>Select</th>
                                          <th>Name</th>
                                          <th>Corporate Email</th>
                                          <th>Phone</th>
                                          <th>Building Location</th>
                                          <th>Remarks</th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {ele?.map(dataItem => {
                                          return (
                                            <tr className="pointerCursor pulse">
                                              <td>
                                                <input
                                                  name={dataItem.radioName}
                                                  type="radio"
                                                  onChange={e =>
                                                    this.handleDuplicateMail(
                                                      e,
                                                      dataItem,
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td className="capitalCase dataFont">
                                                {dataItem.fname}{' '}
                                                {dataItem.lname}
                                              </td>
                                              <td>{dataItem.email}</td>
                                              <td>{dataItem.phone}</td>
                                              <td className="capitalCase">
                                                {
                                                  this.props.importData.data
                                                    ?.buildingName
                                                }
                                              </td>
                                              <td className="text-danger">
                                                {dataItem?.forEmailChk === true
                                                  ? 'Duplicate Email'
                                                  : 'Duplicate Phone'}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                );
                              })}
                            </>

                            {invalidDataStatus?.length > 0 ? (
                              <>
                                <p
                                  style={{
                                    color: 'black',
                                    fontWeight: 'blod',
                                    marginTop: '20px',
                                  }}
                                >
                                  Invalid Records
                                </p>
                              </>
                            ) : (
                              <>
                                <p
                                  style={{
                                    color: 'black',
                                    fontWeight: 'bold',
                                    marginTop: '20px',
                                  }}
                                >
                                  No Invalid Records Found
                                </p>
                              </>
                            )}

                            {invalidDataStatus?.length > 0 ? (
                              <>
                                <p
                                  style={{
                                    color: 'grey',
                                    // fontWeight: '800',
                                    marginTop: '20px',
                                  }}
                                >
                                  These records have one or more invalid fields.{' '}
                                  <span style={{ color: 'black' }}>
                                    They will be discarded
                                  </span>
                                </p>
                              </>
                            ) : (
                              ''
                            )}

                            {invalidDataStatus?.length > 0 ? (
                              <>
                                <p
                                  style={{
                                    color: 'grey',
                                    // fontWeight: '800',
                                    marginTop: '20px',
                                  }}
                                >
                                  Phone no. needs to be 10 to 16 digit long. The
                                  email domain should be registered with us.
                                  Please contact your community team.
                                </p>
                              </>
                            ) : (
                              ''
                            )}

                            {invalidDataStatus?.length > 0 ? (
                              <div className="commonTable customfullwidthmodal2">
                                <table className="table customeTable customeTable1">
                                  <thead>
                                    <tr className="noborderHeader">
                                      {/* <th>Select</th> */}
                                      <th>Name</th>
                                      <th>Corporate Email</th>
                                      <th>Phone</th>
                                      <th>BUILDING LOCATION</th>
                                      <th>Status</th>
                                      <th>Remarks</th>
                                    </tr>
                                  </thead>
                                  {invalidDataStatus?.map(dataItem => {
                                    return (
                                      <tr className="pointerCursor pulse">
                                        <td
                                          className={`capitalCase dataFont ${dataItem.isInvalidName === true
                                            ? 'text-danger font-weight-bold'
                                            : ''
                                            }`}
                                        >
                                          {dataItem?.['First Name']}{' '}
                                          {dataItem?.['Last Name']}
                                        </td>
                                        <td
                                          className={`${dataItem.isInvalidEmail === true
                                            ? 'text-danger font-weight-bold'
                                            : ''
                                            }`}
                                        >
                                          {dataItem.Email}
                                        </td>
                                        <td
                                          className={`${dataItem.isInvalidMob === true
                                            ? 'text-danger font-weight-bold'
                                            : ''
                                            }`}
                                        >
                                          {dataItem?.['Phone No']}
                                        </td>
                                        <td>
                                          {
                                            this.props.importData.data
                                              ?.buildingName
                                          }
                                        </td>
                                        <td
                                          className={`${dataItem.isInvalidStatus === true
                                            ? 'text-danger font-weight-bold'
                                            : ''
                                            }`}
                                        >
                                          {dataItem.Status}
                                        </td>
                                        <td className="text-danger font-weight-bold">
                                          {dataItem.remark}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                  <tbody />
                                </table>
                              </div>
                            ) : (
                              ''
                            )}

                            <div className="text-right pt-4">
                              {this.state.duplicateDataArray?.length > 0 ? (
                                <button
                                  className="btn btn-primary downloadbrn"
                                  onClick={this.addimportfile1}
                                >
                                  Submit
                                </button>
                              ) : (
                                ''
                              )}

                              <button
                                type="button"
                                className="btn btn-secondary  ml-3 mr-3"
                                data-dismiss="modal"
                                onClick={this.refreshPage1}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={
                              loader == true ? 'loader disable' : 'loader'
                            }
                          >
                            <img
                              className=""
                              width={80}
                              src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/loader-sw.gif"
                              alt="Loder"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <SwModal
                  show={this.state.showImportModal}
                  onClose={() => {
                    if (this.state.uploadSuccess) return;
                    this.setState({ showImportModal: false });
                    this.handleReset();
                  }}
                  title="Import Member"
                  size="lg"
                  className="sw-default-modal Mdl_1"
                  footer={
                    <div className="d-flex justify-content-end gap-3">
                      <SwButton
                        variant="dark-outline"
                        onClick={() => {
                          this.setState({ showImportModal: false });
                          this.handleReset();
                        }}
                        disabled={this.state.uploadSuccess}
                      >
                        Cancel
                      </SwButton>

                      <SwButton
                        variant="primary"
                        onClick={this.addimportfile}
                        disabled={this.state.uploadSuccess}
                      >
                        {this.state.uploadSuccess ? 'Uploaded' : 'Submit'}
                      </SwButton>
                    </div>
                  }
                >
                  <div className="row">
                    <div className="col-md-12">
                      <p>
                        Users will be mapped/imported under the selected
                        location.
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    {/* BUILDING */}
                    <div className="col-md-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Building <span className="Required">*</span>
                        </label>
                        <SwSelect
                          options={this.state.buildingOptions}
                          value={this.state.selectedBuilding}
                          onChange={this.handleBuildingChange}
                          placeholder="Select Building"
                          isClearable={false}
                        />
                        <span className="SwTextDanger SwTextSmall">
                          {this.state.buildingLocationError}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-4">
                    {/* DEPARTMENT */}
                    <div className="col-md-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">Department</label>
                        <SwSelect
                          options={options8}
                          value={this.state.deptValue2}
                          onChange={this.changeDept}
                          placeholder="Select..."
                          isClearable={false}
                        />
                      </div>
                    </div>
                  </div>

                  {/* DOWNLOAD + UPLOAD SECTION */}
                  <div className="row">
                    <div className="col-md-6">
                      <label className="SwFormLabel invisible">
                        Upload Member File
                      </label>
                      <div className="SwImportTemplateBox">
                        <a
                          className="SwImportTemplateLink"
                          href="https://d2jovvsod2x1gg.cloudfront.net/csp-files/ImportMember.xlsx"
                          onClick={async (e) => {
                            e.preventDefault();
                            try {
                              const response = await axios.get(
                                'https://d2jovvsod2x1gg.cloudfront.net/csp-files/ImportMember.xlsx',
                                { responseType: 'blob' }
                              );
                              const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
                              const link = document.createElement('a');
                              link.href = blobUrl;
                              link.setAttribute('download', 'ImportMember.xlsx');
                              document.body.appendChild(link);
                              link.click();
                              link.remove();
                              window.URL.revokeObjectURL(blobUrl);
                            } catch (err) {
                              console.error('Template download failed:', err);
                              toast.error('Failed to download template. Please try again.');
                            }
                          }}
                        >
                          <i className="bi bi-download me-2" />
                          Download Member Template
                        </a>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label className="SwFormLabel">
                        Upload Member File{' '}
                        <span className="Required">*</span>
                      </label>
                      <label
                        className="SwImportUploadBox"
                        htmlFor="fileupload"
                        style={
                          this.state.uploadSuccess
                            ? {
                                borderColor: '#00a308',
                                background: '#eafaf0',
                                pointerEvents: 'none',
                              }
                            : this.state.fileName
                            ? {
                                borderColor: '#7ed492',
                                background: '#e8f8ed',
                              }
                            : {}
                        }
                      >
                        <input
                          type="file"
                          id="fileupload"
                          accept=".xlsx"
                          onChange={this.uploadImg}
                          hidden
                          disabled={this.state.uploadSuccess}
                        />
                        {this.state.uploadSuccess ? (
                          <i
                            className="bi bi-check-circle-fill SwImportUploadIcon"
                            style={{ color: '#00a308' }}
                          />
                        ) : this.state.fileName ? (
                          <i
                            className="bi bi-file-earmark-excel-fill SwImportUploadIcon"
                            style={{ color: '#1f8a3a' }}
                          />
                        ) : (
                          <i className="bi bi-cloud-arrow-up SwImportUploadIcon" />
                        )}
                        <span className="SwImportUploadText">
                          {this.state.uploadSuccess ? (
                            <>
                              <span
                                className="SwImportUploadFileName"
                                style={{ color: '#00a308' }}
                              >
                                {this.state.uploadedFileName}
                              </span>
                              <span
                                className="SwTextSmall"
                                style={{ color: '#00a308' }}
                              >
                                File uploaded successfully
                              </span>
                            </>
                          ) : this.state.fileName ? (
                            <>
                              <span
                                className="SwImportUploadFileName"
                                style={{ color: '#1f8a3a' }}
                              >
                                {this.state.fileName}
                              </span>
                              <span
                                className="SwTextSmall"
                                style={{ color: '#1f8a3a' }}
                              >
                                File ready — click to replace
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="fw-600">
                                Click to upload
                              </span>
                              <span className="SwTextSmall SwTextGray">
                                Only .xlsx files
                              </span>
                            </>
                          )}
                        </span>
                      </label>
                      {this.state.fileNameError && !this.state.uploadSuccess && (
                        <span className="SwTextDanger SwTextSmall d-block mt-1">
                          {this.state.fileNameError}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="mt-3">
                    <SwCheckbox
                      id="overwriteExisting"
                      label="Overwrite Existing Data"
                      checked={this.state.confirmcheckbox}
                      onChange={this.handleCheckBox}
                    />
                  </div>
                </SwModal>

                {/* Bulk Upload Error Modal */}
                <SwModal
                  show={this.state.showBulkUploadError}
                  onClose={this.handleBulkUploadError}
                  size="lg"
                  className="sw-default-modal"
                  keyboard={false}
                >
                  <SwButton
                    variant=""
                    className="btn-close btn-close-custom"
                    onClick={this.handleBulkUploadError}
                  />

                  <h3 className="SwModalSubHeading">
                    <img
                      src="./img/BulkUploadErrorModalicon.svg"
                      alt=""
                      className="me-2"
                    />
                    <span>File upload errors found</span>
                  </h3>

                  <div className="BulkErrorMsgContainer">
                    <h5>
                      {uniqueRowCount}{' '}
                      {uniqueRowCount === 1 ? 'row contains' : 'rows contain'}{' '}
                      errors. Please correct them in your original file and
                      re-upload.
                    </h5>

                    <div className="BulkErrorMsg_Table">
                      <div className="table-responsive">
                        <table className="table table-borderless">
                          <thead>
                            <tr>
                              <th scope="col">Row</th>
                              <th scope="col" className="BulkErrorMsg_Field">
                                Field
                              </th>
                              <th
                                scope="col"
                                className="BulkErrorMsg_InputProvided"
                              >
                                Input provided
                              </th>
                              <th scope="col">Required format</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.values(
                              this.state.bulkUploadErrors.reduce(
                                (acc, err) => {
                                  if (!acc[err.row])
                                    acc[err.row] = {
                                      row: err.row,
                                      issues: [],
                                    };
                                  acc[err.row].issues.push(err);
                                  return acc;
                                },
                                {},
                              ),
                            ).map((group, gIndex) =>
                              group.issues
                                .filter(issue => issue && (issue.field || issue.requiredFormat))
                                .map((issue, i) => (
                                  <tr key={`${gIndex}-${i}`}>
                                    <td>{group.row || '-'}</td>
                                    <td>{issue.field || '-'}</td>
                                    <td>{issue.input || '-'}</td>
                                    <td>{issue.requiredFormat || '-'}</td>
                                  </tr>
                                )),
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </SwModal>

                {/* Import Notice Modal */}
                <SwModal
                  show={this.state.showImport}
                  onClose={() =>
                    this.setState({
                      showImport: false,
                      confirmcheckbox: false,
                    })
                  }
                  size="sm"
                  className="sw-small-modal Mdl_2"
                  keyboard={false}
                  footer={
                    <div className="d-flex justify-content-center gap-3">
                      <SwButton
                        variant="dark-outline"
                        size="sm"
                        onClick={() =>
                          this.setState({
                            showImport: false,
                            confirmcheckbox: false,
                          })
                        }
                      >
                        Cancel
                      </SwButton>
                      <SwButton
                        variant="primary"
                        size="sm"
                        onClick={() => this.setState({ showImport: false })}
                      >
                        Continue
                      </SwButton>
                    </div>
                  }
                >
                  <SwButton
                    variant=""
                    className="btn-close btn-close-custom"
                    onClick={() =>
                      this.setState({
                        showImport: false,
                        confirmcheckbox: false,
                      })
                    }
                  />

                  <h3 className="SwModalSubHeading">Notice</h3>

                  <p className="mb-1">
                    Using this option will deactivate all users that are not
                    included in your upload file. Click Continue if you wish
                    to proceed.
                  </p>
                </SwModal>

                <SwModal
                  show={this.state.showCompleteReviewModal}
                  onClose={() => this.setState({ showCompleteReviewModal: false })}
                  size="sm"
                  className="sw-small-modal"
                  footer={
                    <div className="d-flex justify-content-center gap-3">
                      <SwButton variant="dark-outline" size="sm" onClick={() => this.setState({ showCompleteReviewModal: false })}>Cancel</SwButton>
                      <SwButton variant="dark" size="sm" onClick={() => { this.completeReview(); this.setState({ showCompleteReviewModal: false }); }}>Yes</SwButton>
                    </div>
                  }
                >
                  <SwButton variant="" className='btn-close btn-close-custom' onClick={() => this.setState({ showCompleteReviewModal: false })} ></SwButton>

                  <h3 className="SwModalSubHeading">Confirmation</h3>
                  <p className="mb-1">
                    <strong>
                      Are you sure, you want to complete the member review
                    </strong>
                  </p>
                </SwModal>

                <div class="PageContent MemberAccess-Page">
                  {/* <!-- Member Review --> */}

                  {localStorage.getItem('exitReview') == 'false' ? (
                    <div class="member_review_box px-4 mb-4">
                      <div class="memberReview_header d-flex align-items-center">
                        <div class="d-flex align-self-center">
                          <h2>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="21"
                              height="17"
                              viewBox="0 0 21 17"
                              fill="none"
                            >
                              <path
                                d="M-0.000976562 14V12H8.99902V14H-0.000976562ZM-0.000976562 6.00005V4.00005H8.99902V6.00005H-0.000976562ZM12.399 17L10.999 15.6L13.599 13L10.999 10.4L12.399 9.00005L14.999 11.6L17.599 9.00005L18.999 10.4L16.399 13L18.999 15.6L17.599 17L14.999 14.4L12.399 17ZM14.549 8.00005L10.999 4.45005L12.399 3.05005L14.524 5.17505L18.774 0.925049L20.174 2.35005L14.549 8.00005Z"
                                fill="white"
                              />
                            </svg>
                            &nbsp; Member Review
                          </h2>
                        </div>

                        <div class="ms-auto memberReview_status">Ongoing</div>
                      </div>

                      <div class="memberReview_body">
                        <div class="d-flex">
                          <div class="text-nowrap">Reviewing members of </div>
                          <div class="memberLocation_badges_container">
                            {labelName &&
                              labelName.map(label => (
                                <span class="memberLocation_badges">
                                  {label}
                                </span>
                              ))}
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-start py-3 gap-3">

                        <SwButton
                          variant="light-outline"
                          size="sm"
                          onClick={() => {
                            this.exitReview();
                            window.location.href = '/Dashboard';
                          }}
                        >
                          Exit review
                        </SwButton>
                        <SwButton
                          variant="primary"
                          size="sm"
                          disabled={!(labelName && labelName.length > 0)}
                          onClick={() => this.setState({ showCompleteReviewModal: true })}
                          className="ml10"
                        >
                          Complete review
                        </SwButton>

                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="row">
                    <div className="col-md-3">
                      <div className="SwHeading">
                        <h2 className="mb-1">Member Access</h2>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="PageHead_Optons_Row">
                        <ul className="PageHead_Optons_RightAligned">
                          <li>
                            <div className="SwInputWithIcon">
                              <SwInput
                                placeholder="Search..."
                                value={this.state.searchText}
                                onChange={this.changeFilterData}
                              />
                              <span className="SwInputicon">
                                <i className="bi bi-search" />
                              </span>
                            </div>
                          </li>

                          <li className="ToHideMobile">
                            <MainHeadingFilterMember
                              filterPg={this.state.pgno}
                              clearSearch={this.clearSearchBox}
                              filterRow={this.state.row}
                              companyid={this.state.company_id}
                              onSelectLanguage={this.handleLanguage}
                              getAllExportData={this.getAllExportData}
                            />
                          </li>

                          <li className="ToHideMobile">
                            <AntDDropdown
                              menu={{
                                onClick: ({ key }) => {
                                  // Handle sort keys
                                  if (
                                    [
                                      'name',
                                      'email',
                                      'phone',
                                      'status',
                                    ].includes(key)
                                  ) {
                                    this.setSelectsort(key);
                                  }

                                  if (key === 'import') {
                                    this.importClick();
                                  }

                                  if (key === 'refresh') {
                                    this.refreshPage1();
                                  }

                                  if (key === 'company-setting') {
                                    this.setState({ showCompanySetting: true });
                                  }
                                },
                                items: [
                                  {
                                    key: 'sort',
                                    label: 'Sort by',
                                    icon: <i className="bi bi-sort-down-alt" />,
                                    children: [
                                      {
                                        key: 'name',
                                        label: 'Name',
                                        className: 'SortingMenu',
                                      },
                                      {
                                        key: 'email',
                                        label: 'Corporate Email',
                                        className: 'SortingMenu',
                                      },
                                      {
                                        key: 'phone',
                                        label: 'Phone',
                                        className: 'SortingMenu',
                                      },
                                      {
                                        key: 'status',
                                        label: 'Status',
                                        className: 'SortingMenu',
                                      },
                                    ],
                                  },

                                  ...(ManageMembers?.role_for_write === '1'
                                    ? [
                                      {
                                        key: 'export-loading',
                                        label: this.state.loadingExport,
                                      },
                                    ]
                                    : []),

                                  ...(Number(UserObj?.company_id) !==
                                    Number(
                                      process.env.REACT_APP_TALBOT_COM_ID,
                                    ) && ManageMembers?.role_for_write === '1'
                                    ? [
                                      {
                                        key: 'import',
                                        icon: (
                                          <i className="bi bi-download" />
                                        ),
                                        label: (
                                          <div
                                            onClick={() =>
                                              this.setState({
                                                showImportModal: true,
                                              })
                                            }
                                          >
                                            <span>Import Members</span>
                                          </div>
                                        ),
                                      },
                                    ]
                                    : []),

                                  {
                                    key: 'refresh',
                                    icon: (
                                      <i className="bi bi-arrow-clockwise" />
                                    ),
                                    label: 'Refresh List',
                                  },

                                  {
                                    key: 'company-setting',
                                    icon: <i className="bi bi-gear" />,
                                    label: 'Company Setting',
                                  },
                                ],
                              }}
                              trigger={['click']}
                              placement="bottomRight"
                            >
                              <SwIconButton size="sm">
                                <i className="bi bi-list" />
                              </SwIconButton>
                            </AntDDropdown>
                          </li>

                          <li className="">
                            {ManageMembers ? <MainHeadingAddMember /> : false}
                          </li>
                        </ul>

                        <SwOffCanvas
                          show={this.state.showCompanySetting}
                          onClose={() =>
                            this.setState({ showCompanySetting: false })
                          }
                          title="Default permissions"
                          placement="end"
                          backdrop="static"
                          keyboard={false}
                          footer={
                            <div className="OffCanvasFooter_Btns">
                              <SwButton
                                type="button"
                                variant="dark-outline"
                                onClick={() =>
                                  this.companySettingRef.current?.resetForm()
                                }
                              >
                                Reset
                              </SwButton>
                              <SwButton
                                variant="primary"
                                onClick={e =>
                                  this.companySettingRef.current?.handleUpdate(
                                    e,
                                  )
                                }
                              >
                                Update
                              </SwButton>
                            </div>
                          }
                        >
                          <CompanyLevelSettingModal
                            ref={this.companySettingRef}
                            onSuccess={this.closeAddMember}
                          />
                        </SwOffCanvas>

                        {/* Company Level Setting Modal Import */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <MemberInformationPannel
                        getActiveMember={this.getActiveMember}
                      />

                      {/* Edit Member OffCanvas */}
                      <SwOffCanvas
                        show={this.state.showEditMember}
                        onClose={this.closeEditMember}
                        title="Edit Member"
                        placement="end"
                        backdrop="static"
                        keyboard={false}
                        footer={(() => {
                          const fs = this.state.footerState;
                          if (!fs) return null;

                          const {
                            isApproved1,
                            isApproved,
                            ManageApproval1,
                            ManageMembers,
                            btnStatus,
                          } = fs;

                          return isApproved1 == 1 &&
                            isApproved === 0 &&
                            ((ManageApproval1 &&
                              ManageApproval1.role_for_write == '1') ||
                              ManageApproval1?.role_for_read == '1') ? (
                            <div className="OffCanvasFooter_Btns">
                              <SwButton
                                disabled={
                                  ManageApproval1?.role_for_write != '1'
                                }
                                variant="danger-outline"
                                onClick={() =>
                                  this.editMemberRef.current?.handleShowDeny()
                                }
                              >
                                Deny Request
                              </SwButton>

                              <SwButton
                                variant="primary"
                                disabled={
                                  ManageApproval1?.role_for_write != '1'
                                }
                                onClick={() =>
                                  this.editMemberRef.current?.handleShowGrant()
                                }
                              >
                                Grant Access
                              </SwButton>
                            </div>
                          ) : (
                            <div className="OffCanvasFooter_Btns">
                              <SwButton
                                variant="dark-outline"
                                onClick={() =>
                                  this.editMemberRef.current?.reload()
                                }
                              >
                                Reset
                              </SwButton>

                              {!btnStatus ? (
                                <SwButton
                                  variant="primary"
                                  
                                  disabled={
                                    ManageMembers?.role_for_write != '1'
                                  }
                                  onClick={e =>
                                    this.editMemberRef.current?.EditSubmit(e)
                                  }
                                >
                                  Update
                                </SwButton>
                              ) : (
                                <SwButton
                                  variant="dark"
                                  disabled
                                  className="ml10"
                                >
                                  <i className="fa fa-refresh fa-spin" />{' '}
                                  Processing
                                </SwButton>
                              )}
                            </div>
                          );
                        })()}
                      >
                        <EditMember
                          ref={this.editMemberRef}
                          onFooterState={this.onFooterState}
                          onClose={this.closeEditMember}
                          onSuccess={this.closeEditMember}
                          epg={this.state.pgno}
                          erw={this.state.row}
                        />
                      </SwOffCanvas>

                      {/* Delete User Modal */}
                      <SwModal
                        show={this.state.showDeleteUserList}
                        onClose={() =>
                          this.setState({ showDeleteUserList: false })
                        }
                        className="sw-small-modal"
                        footer={
                          <div className="d-flex justify-content-center gap-3">
                            <SwButton
                              variant="dark-outline"
                              size="sm"
                              onClick={() =>
                                this.setState({ showDeleteUserList: false })
                              }
                            >
                              Cancel
                            </SwButton>

                            <SwButton
                              variant="primary"
                              size="sm"
                              onClick={() => {
                                this.getDelete(this.state.testRec);
                                this.setState({ showDeleteUserList: false });
                              }}
                            >
                              Confirm
                            </SwButton>
                          </div>
                        }
                      >
                        <h3 className="SwModalSubHeading">Alert !!</h3>
                        <p>
                          Are you sure you want to delete this user's request?
                        </p>
                      </SwModal>

                      <div className="">
                        <AntDTable
                          columns={columns}
                          dataSource={
                            activeUserList && activeUserList.list
                              ? activeUserList.list
                              : []
                          }
                          loading={loader}
                          pagination={true}
                          currentPage={this.state.pgno}
                          totalRecords={
                            this.props.activeUserList?.userList?.total || 0
                          }
                          pageSize={this.state.row}
                          onChange={this.handleTableChange}
                          showTotal={true}
                          rowKey="rec_id"
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <MarketingPanel />
            )}
          </Layout>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => {
  const datafooter = state.activeUserList?.userList?.list;

  return {
    activeUserList: state.activeUserList,
    latestList: state?.activeUserList?.latestList?.total || 0,
    exportList: state.activeUserList,
    visitorReducer: state.visitorReducer,
    visitor1: datafooter != undefined ? datafooter : [],
    newMemberData: state.activeUserList,
    CityData1: state.activeUserList,
    importData: state.activeUserList.builkfiledata,
  };
};

const mapActionsToProps = {
  allMember,
  CheckLoader,
  exportFileFunc,
  addBulkUploadFile,
  memberAditionData,
  onBuildingLocation1,
  onCityLocation1,
  addBulkUploadFile2,
  ActiveListsetEdit,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(ActiveMember);
